
import CeGeometry from './CeGeometry';
import CeVertex from './CeVertex';
import GCPolygon from './GCPolygon';
import StringList from '../utility/StringList';
import CeIODataItem from '../CeFileIO/CeIODataItem';

const CeCircle = function (type) {
  var geomType = "Circle";
  if (type != null && type !== undefined)
    geomType = type;
  CeGeometry.call(this, geomType);

  this.mCenter = new CeVertex();
  this.mDiameter = 0.0;
}

// subclass extends superclass
CeCircle.prototype = Object.create(CeGeometry.prototype);
CeCircle.prototype.constructor = CeCircle;

CeCircle.prototype.CopyFrom = function (fromObj) {
  this.mCenter.CopyFrom(fromObj.mCenter);
  this.mDiameter = fromObj.mDiameter;
  CeGeometry.prototype.CopyFrom.call(this, fromObj);
}

CeCircle.prototype.Clone = function () {
  var clnObj = new CeCircle();
  clnObj.CopyFrom(this);
  return clnObj;
}

CeCircle.prototype.SetData = function (cx, cy, diameter) {
  this.mCenter.SetData(cx, cy);
  this.mDiameter = diameter;
}

CeCircle.prototype.GetDataString = function () {
  var defData = new StringList();
  defData.push(this.mCenter.mX);
  defData.push(this.mCenter.mY);
  defData.push(this.mDiameter);
  return defData;
}

CeCircle.prototype.GetCenter = function () {
  return this.mCenter;
}

CeCircle.prototype.GetDiameter = function () {
  return this.mDiameter;
}

CeCircle.prototype.UpdateByString = function (dataVals) {
  // llX, llY, urX, urY
  if (dataVals.size() !== 3)
    return false;

  var minPntVals = new StringList();
  minPntVals.push(dataVals.get(0));
  minPntVals.push(dataVals.get(1));
  this.mCenter.UpdateByString(minPntVals);

  this.mDiameter = parseFloat(dataVals.get(2));

  return true;
}

CeCircle.prototype.WriteIntoIODataNode = function () {
  var dataVals = this.GetDataString();
  return new CeIODataItem(this.GetGeomType(), dataVals);
}

CeCircle.prototype.ReadFromIODataNode = function (fileItem) {
  var dataVals = fileItem.GetItemValue();
  return this.UpdateByString(dataVals);
}

CeCircle.prototype.Transform = function (celocation) {
  this.mCenter.Transform(celocation.mRotAngle, celocation.mCW, celocation.mPosition, celocation.mFlipOnX, celocation.mFlipOnY);
}

CeCircle.prototype.ConvertToGCPolygon = function () {
  var xArray = [];
  var yArray = [];

  var ndiv = 20;
  var radius = 0.5 * this.mDiameter;
  var delta = 2 * Math.PI / ndiv;

  for (var i = 0; i < ndiv; i++) {
    xArray.push(Math.cos(i * delta) * radius + this.mCenter.mX);
    yArray.push(Math.sin(i * delta) * radius + this.mCenter.mY);
  }
  var gcPolygon = new GCPolygon();
  gcPolygon.SetData(ndiv, xArray, yArray);
  return gcPolygon;
}

CeCircle.prototype.mConvertToGCPolygon = function () {
  var xArray = [];
  var yArray = [];

  var ndiv = 20;
  var radius = 0.5 * this.mDiameter;
  var delta = 2 * Math.PI / ndiv;

  for (var i = 0; i < ndiv; i++) {
    xArray.push(Math.cos(i * delta) * radius + this.mCenter.mX);
    yArray.push(Math.sin(i * delta) * radius + this.mCenter.mY);
  }
  var gcPolygon = new GCPolygon();
  gcPolygon.SetData(ndiv, xArray, yArray);
  return gcPolygon;
}

export default CeCircle;